import EditableRichTextInput from 'Global/Components/EditableComponents/EditableRichTextInput/EditableRichTextInput';
import React, { useEffect, useState } from 'react';

const AgreementHTMLEditor = ({
  field,
  onChange,
  agreement_rules_title,
}) => {
  return (
    <React.Fragment>
      {/* <p
        style={{
          marginTop: '2em',
          textAlign: 'center',

          paddingInline: '-2em',
        }}
      >
        {agreement_rules_title}
      </p> */}
      <div>
        <EditableRichTextInput
          element={field}
          onChange={onChange}
          getHTML={true}
          field={field}
          placeholder={agreement_rules_title}
        />
      </div>
    </React.Fragment>
  );
};

export default AgreementHTMLEditor;
